import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const headingStyles = style({
  fontSize: vars.fontSizes.heading.m,
});

export const formWrapper = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
});
